import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './Home.component';
import { ConfigurationComponent } from '../Configuration/configuration.component';
import { MaintenanceComponent } from '../Maintenance/Maintenance.component';

import { AuthGuard } from '../guards/auth.guard';
import { HomeModule } from './home.module';

const homeRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        children: [
            { path: 'configuration', component: ConfigurationComponent },
            { path: 'configuration/:model', component: ConfigurationComponent },
            { path: 'maintenance', component: MaintenanceComponent },
            { path: '', redirectTo: 'configuration', pathMatch: 'full' }
        ]
    }
];

export const homeRouting: ModuleWithProviders<HomeModule> = RouterModule.forChild(homeRoutes);
